import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';

const ContactEmailContainer = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const ContactIcon = styled.div`
  width: 28px;
  height: 28px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(15%) sepia(15%) saturate(3207%) hue-rotate(202deg) brightness(95%) contrast(101%);
    opacity: 1;
  }

  @media (max-width: 480px) {
    width: 24px;
    height: 24px;

    img {
      width: 20px;
      height: 20px;
    }
  }
`;

const ContactText = styled.span`
  font-family: ${theme.fonts.body};
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: ${theme.colors.outchou_blue};

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

interface ContactEmailProps {
  className?: string;
}

const ContactEmail: React.FC<ContactEmailProps> = ({ className }) => {
  const email = 'contact@outchou.com';
  
  return (
    <ContactEmailContainer 
      href={`mailto:${email}`}
      className={className}
      aria-label={`Envoyer un email à ${email}`}
    >
      <ContactIcon>
        <img src="/shared_assets/images/mail_icon.png" alt="Email" />
      </ContactIcon>
      <ContactText>{email}</ContactText>
    </ContactEmailContainer>
  );
};

export default ContactEmail;
